import * as React from 'react';
import { Desktop, Mobile, Tablet } from '../common/responsive';
import { MAIN_PAGE_CONTENT } from '../../constants/page-content';
import { ViewDesktop } from './views/Desktop';
import { ViewMobile } from './views/Mobile';
import { ViewTablet } from './views/Tablet';

export const MainPage = () => (
  <div>
    <Mobile>
      <ViewMobile content={MAIN_PAGE_CONTENT} />
    </Mobile>
    <Tablet>
      <ViewTablet content={MAIN_PAGE_CONTENT} />
    </Tablet>
    <Desktop>
      <ViewDesktop content={MAIN_PAGE_CONTENT} />
    </Desktop>
  </div>
)
